<template>
    <div>

        <!-- Modal -->
        <div class="modal fade" id="terceiroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="terceiro">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Terceirizado
                            <span class="badge badge-secondary ml-2">
                                {{ terceiro.id_procedimento_terceiro ? '#' + terceiro.id_procedimento_terceiro : 'novo' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-10" v-if="origem == 'terceiro'">
                                <az-input
                                    label="Procedimento"
                                    placeholder="Selecione o procedimento..."
                                    type="autocomplete"
                                    service="procedimentos.index"
                                    optionsMode="aql"
                                    optionsName="procedimentos.index"
                                    optionsData="id_procedimento"
                                    v-model="terceiro.id_procedimento" />
                            </div>

                            <div class="col col-12 col-md-10" v-else>
                                <az-input
                                    label="Terceiro"
                                    type="select"
                                    required
                                    :validate="validate"
                                    :optionsList="terceiros"
                                    optionsData="id_terceiro"
                                    optionsDisplay="search"
                                    v-model="terceiro.id_terceiro" />
                            </div>

                            <div class="col col-12 col-md-2">
                                <az-input
                                    label="Ordem"
                                    required
                                    :validate="validate"
                                    v-model="terceiro.in_regra_ordem" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Material"
                                    placeholder="Qualquer Material..."
                                    type="select"
                                    optionsData="id_amostra_material"
                                    service="amostra_materiais.index"
                                    optionsMode="aql"
                                    v-model="terceiro.id_amostra_material"
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 " :class="is_shift ? 'col-md-3' : 'col-md-6'">
                                <az-input
                                    label="Código do Exame"
                                    required
                                    :validate="validate"
                                    v-model="terceiro.st_codigo_terceiro" />
                            </div>
                            <div class="col col-12 col-md-3" v-if="is_shift">
                                <az-input
                                    label="Código Mnemonico do exame"
                                    required
                                    :validate="validate"
                                    v-model="terceiro.st_mnemonico" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Código do Material"
                                    placeholder="Selecionado no Atendimento..."
                                    :validate="validate"
                                    v-model="terceiro.st_material_terceiro" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12">
                                <az-input
                                    label="Ativo"
                                    type="checkbox-group"
                                    v-model="terceiro.fl_ativo" />
                            </div>
                        </div>

                        <!-- Classificação -->
                        <div class="row mt-3">
                            <div class="col col-12">
                                <small class="text-muted">Classificação</small>
                                <multiselect
                                    v-model="terceiro.js_classes"
                                    :options="options_classes"
                                    :multiple="true"
                                    :taggable="true"
                                    @tag="addTag"
                                    placeholder="Selecione uma classificação..."
                                    selectLabel="Pressione [ENTER] para selecionar"
                                    deselectLabel="Pressione [ENTER] para remover"
                                    tagPlaceholder="Pressione [ENTER] para incluir"
                                    selectedLabel="Selecionado">
                                    <template slot="noOptions">
                                        Nenhuma classificação criada.
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <!-- Filtros -->
                        <filtro-model class="my-3" v-model="terceiro.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button :id="terceiro.id_procedimento_terceiro" model="procedimentoTerceiro" />
                        <az-submit color="danger" @click="remover_terceiro()" v-if="terceiro.id_procedimento_terceiro">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_terceiro()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import FiltroModel from '../shared/FiltroModel.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Multiselect from 'vue-multiselect';

export default {
    data() {
        return { 
            validate: false, 
            terceiro: null, 
            tags_carregadas: false, 
            terceiros: [], 
            options_classes: [],
        }
    },

    components: { 
        AzInput, 
        AzSubmit, 
        FiltroModel,
        AzAuditLogButton, 
        Multiselect, 
    },

    props: ['origem'], 

    computed: { 
        is_shift: function() {
            if(this.terceiros && this.terceiro && this.terceiro.id_terceiro) {
                const shift = _.find(this.terceiros, {id_terceiro: this.terceiro.id_terceiro});

                return (shift && shift.st_terceiro && shift.st_terceiro.toUpperCase() == 'SHIFT');
            }

            return false;
        },

        lista_opcoes_filtro: function () {
            return [
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'},
                {id:'App\\azure\\plano', search:'Plano', service: 'planos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'},
            ];
        },
    },

    methods: { 
        carregar_tags () { 
            if ( this.tags_carregadas ) { 
                return;
            }

            this.tags_carregadas = true;

            this.$util.loadItem(this, { 
                service: 'procedimento_terceiros',
                func: 'tags',
            })
            .then(res => { 
                this.options_classes = res;
            });
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.terceiro.js_classes )
                this.terceiro.js_classes = [];

            this.terceiro.js_classes.push(newTag);
        },

        editar(id_procedimento_terceiro) { 
            this.carregar_tags(); 

            this.terceiro = null; 
            this.validate = false; 

            if ( !this.terceiros.length ) { 
                this.$util.loadItem(this, { 
                    service: 'terceiros',
                    func: 'index',
                })
                .then(res => { 
                    this.terceiros = res;
                });
            }

            this.$util.load(this, { 
                service: 'procedimento_terceiros',
                func: 'show',
                parms: { 
                    id: id_procedimento_terceiro,
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.terceiro = res;
                    $('#terceiroModal').modal('show');
                }
            });
        },

        remover_terceiro () {
            if ( !confirm("Confirma remover este item?") )
                return;

            this.$util.remover(this, {
                service: 'procedimento_terceiros',
                dados: this.terceiro,
                modal: 'terceiroModal',
                toast: true,
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        salvar_terceiro() {
            this.$util.atualizar(this, {
                service: 'procedimento_terceiros',
                func: 'store',
                dados: this.terceiro,
                modal: 'terceiroModal',
                toast: true,
                callback: () => {
                    this.$emit('refresh');
                }
            });
        },

        incluir_terceiro(parms = {}) {
            this.carregar_tags(); 

            if ( !this.terceiros.length ) { 
                this.$util.loadItem(this, { 
                    service: 'terceiros',
                    func: 'index',
                })
                .then(res => { 
                    this.terceiros = res;
                });
            }
            
            this.validate = false;

            this.terceiro = {
                id_procedimento_terceiro: null,
                id_procedimento: null,
                id_terceiro: null,
                id_amostra_material: "",
                st_codigo_terceiro: "",
                st_material_terceiro: "",
                fl_ativo: true,
                in_regra_ordem: 100,
                filtros: [],
                ...parms, 
            };

            $('#terceiroModal').modal('show');
        },
    }
}
</script>
